import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { athenaGreen, statRed } from '../../globals';


class LoadingCheckbox extends React.Component{
  static propTypes = {
    loading: PropTypes.bool,
  };

  static defaultProps = {
    loading: false,
  };

  render() {
    const { loading, children, classes, ...checkboxProps } = this.props;
    if (loading) {
      checkboxProps.disabled = true;
    }
    const GreenCheckbox = withStyles({
      root: {
        color: statRed,
        '&$checked': {
          color: athenaGreen,
        },
      },
      checked: {},
    })(props => <Checkbox color="default" {...props} />);
    const { substep } = checkboxProps;
    if (substep.action === 'automatic') {
      return null;
    }
    return (
      <FormControlLabel
        control={
          loading
            ? <CircularProgress size={42} />
            : <GreenCheckbox
              checked={substep.checked}
              onClick={event => checkboxProps.onCheckChange(substep)}
              value={substep.checked}
            />
        }
      />
    );
  }
}


export default LoadingCheckbox;
